/* Gift card page (sections/main-gift-card.liquid). Vanilla, small.
   Amount chips write the variant id and the bar amount; delivery toggles the
   date field; the timezone offset rides along so Shopify sends the card on
   the buyer's day, not UTC's; the button sits in flow under Delivery. */
(function () {
  'use strict';
  var root = document.querySelector('[data-gc]');
  if (!root) return;
  function ga(name, params) {
    if (typeof window.gtag === 'function') window.gtag('event', name, params || {});
  }

  /* --- Amount --- */
  var variantInput = root.querySelector('[data-gc-variant]');
  var barAmount = root.querySelector('[data-gc-bar-amount]');
  var amounts = Array.prototype.slice.call(root.querySelectorAll('[data-gc-amount]'));
  function pickAmount(btn) {
    amounts.forEach(function (b) { b.setAttribute('aria-checked', b === btn ? 'true' : 'false'); });
    variantInput.value = btn.getAttribute('data-variant-id');
    if (barAmount) barAmount.textContent = btn.getAttribute('data-price');
  }
  amounts.forEach(function (b) {
    b.addEventListener('click', function () {
      if (b.getAttribute('aria-checked') === 'true') return;
      pickAmount(b);
      ga('gift_card_amount_selected', { value: b.getAttribute('data-price'), item_id: root.getAttribute('data-product-id') });
    });
  });

  /* --- Delivery --- */
  var whenBtns = Array.prototype.slice.call(root.querySelectorAll('[data-gc-when]'));
  var dateField = root.querySelector('[data-gc-date-field]');
  var dateInput = root.querySelector('[data-gc-date]');
  var offsetInput = root.querySelector('[data-gc-offset]');
  if (offsetInput) offsetInput.value = new Date().getTimezoneOffset().toString();
  function isoLocal(d) {
    var m = d.getMonth() + 1, day = d.getDate();
    return d.getFullYear() + '-' + (m < 10 ? '0' : '') + m + '-' + (day < 10 ? '0' : '') + day;
  }
  var minDate = null;
  if (dateInput) {
    /* Tomorrow at the earliest (AS, 2026-09-13): today is "Immediately". */
    var tomorrow = new Date(), max = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    max.setDate(max.getDate() + 90);
    minDate = isoLocal(tomorrow);
    dateInput.min = minDate;
    dateInput.max = isoLocal(max);
  }
  /* One icon: the read-only text field shows the date, the real date input is
     off-screen and opened with showPicker(). No showPicker (old Safari): show
     the native input in the row instead. */
  var dateText = root.querySelector('[data-gc-date-text]');
  var dateRow = root.querySelector('.gc__date');
  var dateOpen = root.querySelector('[data-gc-date-open]');
  var hint = root.querySelector('[data-gc-hint]');
  var canPick = dateInput && typeof dateInput.showPicker === 'function';
  if (dateRow && !canPick) dateRow.classList.add('gc__date--native');
  function openPicker() {
    if (!dateInput) return;
    dateInput.disabled = false;
    if (canPick) {
      try { dateInput.showPicker(); return; } catch (e) { /* needs a user gesture; fall through */ }
    }
    dateInput.focus();
  }
  function showDate() {
    if (!dateText || !dateInput) return;
    var v = dateInput.value;
    if (!v) { dateText.value = ''; return; }
    var p = v.split('-');
    dateText.value = p[1] + '/' + p[2] + '/' + p[0];
  }
  if (dateOpen) dateOpen.addEventListener('click', openPicker);
  if (dateText) {
    dateText.addEventListener('click', openPicker);
    dateText.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openPicker(); } });
  }
  if (dateInput) dateInput.addEventListener('change', showDate);
  whenBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      whenBtns.forEach(function (x) { x.setAttribute('aria-checked', x === b ? 'true' : 'false'); });
      var custom = b.getAttribute('data-gc-when') === 'date';
      if (dateField) dateField.hidden = !custom;
      if (dateInput) {
        dateInput.disabled = !custom;   /* disabled = not submitted = "send now" */
        dateInput.required = custom;
      }
      /* The note follows the choice (AS, 2026-09-13). */
      if (hint) hint.textContent = hint.getAttribute(custom ? 'data-hint-date' : 'data-hint-now') || '';
      if (custom) openPicker();
    });
  });

  /* --- Message counter --- */
  var msg = root.querySelector('[data-gc-message]');
  var count = root.querySelector('[data-gc-count]');
  if (msg && count) {
    msg.addEventListener('input', function () { count.textContent = msg.value.length + '/200'; });
  }

  /* --- Submit guard: the sticky button is outside the form, so native
         validation still runs, but a clear line beats a browser bubble. --- */
  var form = root.querySelector('[data-gc-form]');
  var err = root.querySelector('[data-gc-error]');
  if (form) {
    form.addEventListener('submit', function (e) {
      err.hidden = true;
      var email = form.querySelector('input[type="email"]');
      if (!email.value.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim())) {
        e.preventDefault();
        err.textContent = 'Enter the email address of the person who will receive the gift card.';
        err.hidden = false;
        email.focus();
        return;
      }
      if (dateInput && !dateInput.disabled) {
        if (!dateInput.value) {
          e.preventDefault();
          err.textContent = 'Pick the date to send it, or choose Immediately.';
          err.hidden = false;
          dateInput.focus();
          return;
        }
        if (minDate && dateInput.value < minDate) {
          e.preventDefault();
          err.textContent = 'Pick a date from tomorrow on. For today, choose Immediately.';
          err.hidden = false;
          dateInput.focus();
          return;
        }
        if (dateInput.max && dateInput.value > dateInput.max) {
          e.preventDefault();
          err.textContent = 'Pick a date within the next 90 days.';
          err.hidden = false;
          dateInput.focus();
        }
      }
    });
  }

})();
